var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#142654",
    d: "M5.064 3.061c0 .684-.256 1.34-.712 1.824a2.356 2.356 0 0 1-1.716.755A2.357 2.357 0 0 1 .92 4.883 2.665 2.665 0 0 1 .21 3.06c0-.685.256-1.34.711-1.824A2.356 2.356 0 0 1 2.638.48c.644 0 1.261.272 1.716.756.455.485.71 1.14.71 1.825Zm.073 4.49H.282V23.7h4.855V7.55Zm7.67 0h-4.83V23.7h4.781v-8.475c0-4.722 5.79-5.16 5.79 0V23.7h4.793V13.47c0-7.959-8.568-7.662-10.583-3.754l.049-2.167Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e4ee83d01f2fbe70687529c610a268c4.svg";
export { ForwardRef as ReactComponent };